export default __webpack_public_path__ + "static/media/file-pdf.a8229a57.svg";